import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { useSelector } from 'store/hooks';
import DonutCard from '../../../../components/DashboardComponents/DashboardGraphs/DonutChartDashboard';
import PendingAtBarChart from '../../../../components/DashboardComponents/DashboardGraphs/PendingAtBarChart';
import KpiMetricsTable from './KpiMetricsTable/KpiMetricsTable';

const KpiMetricsWorkflow = ({
  donutDataConsultant,
  donutDataDM,
  donutDataClient,
  COLORS_CONSULTANT,
  COLORS_DM,
  COLORS_CLIENT,
  barChartData,
  metric,
  data_table,
  onDownloadXlsx,
  showDownload,
}) => {
  const { loadings } = useSelector((state) => state);
  const workFlowLabels = [
    { labelname: 'Complete', color: '#61D2A4', dataKey: 'completed', toolbarText: 'completedRaw' },
    { labelname: 'Pending Client', color: '#3B82F6', dataKey: 'pendingClient', toolbarText: 'pendingClientRaw' },
    { labelname: 'Pending DM', color: '#FF6040', dataKey: 'pendingDM', toolbarText: 'pendingDMRaw' },
    {
      labelname: 'Pending Consultant',
      color: '#FFC107',
      dataKey: 'pendingConsultant',
      toolbarText: 'pendingConsultantRaw',
    },
  ];
  return (
    <>
      {/* Donut Chart Row */}
      <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
        {[
          { title: 'Consultant Submission', data: donutDataConsultant, colors: COLORS_CONSULTANT },
          { title: 'DM Validation', data: donutDataDM, colors: COLORS_DM },
          { title: 'Client Acceptance', data: donutDataClient, colors: COLORS_CLIENT },
        ].map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Paper
              sx={{
                minWidth: { xs: '100%', sm: '260px', md: '290px' },
                height: { xs: '280px', sm: '300px', md: '284px', lg: '284px' },
                flexGrow: 1,
                flexBasis: 0,
                borderRadius: 2,
                p: 1.5,
                boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
              {item.title}
            </Typography> */}
              <DonutCard
                title={item.title}
                data={Object.entries(item?.data ?? {}).map(([name, value]) => ({ name, value }))}
                colors={item.colors}
                chartHeight={180}
              />
            </Paper>
          </Grid>
        ))}
      </Grid>
      {/* Pending at Bar Chart */}
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
              borderRadius: 2,
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600, mb: 1 }}>
              Pending at
            </Typography>
            <PendingAtBarChart data={barChartData} height={250} baseLabels={workFlowLabels} />
          </Paper>
        </Grid>
      </Grid>
      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            {/* <KpiMetricsTable FilterKpiMetric={metric} dashboardKpiGridData={[]} FilterNeeded={false} /> */}
            <KpiMetricsTable
              FilterKpiMetric={metric}
              dashboardKpiGridData={data_table}
              FilterNeeded={false}
              isLoading={Boolean(loadings?.dashboardKpiGrid)}
              onDownloadXlsx={onDownloadXlsx}
              showDownload={showDownload}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsWorkflow;
